namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoHd1Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoHd1';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoHd1Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoHd1Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoHd1Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoHd1Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoHd1/Create",
            Update = "AdvPromo/PsAdvPromoHd1/Update",
            Delete = "AdvPromo/PsAdvPromoHd1/Delete",
            Retrieve = "AdvPromo/PsAdvPromoHd1/Retrieve",
            List = "AdvPromo/PsAdvPromoHd1/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoHd1Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
